import { readonly, ref, watch, type ComputedRef, type Ref } from 'vue'
import { defineStore, storeToRefs } from 'pinia'
import { useEventBus, useListen } from '@/plugins/event-bus'

const useFilterButtonCountStore = defineStore('filterButtonCount', () => {
    const count = ref(0)
    const updateCount = (c: number) => {
        count.value = c
    }

    return {
        count,
        updateCount,
    }
})

export const useFilterButton = (): {
    count: Readonly<Ref<number, number>>
    openFilterModal: () => void
} => {
    const { count } = storeToRefs(useFilterButtonCountStore())

    const bus = useEventBus()
    const openFilterModal = () => bus.emit('open-filter-modal')

    return {
        count: readonly(count),
        openFilterModal,
    }
}

export const useFilterButtonClient = (
    onOpen: () => void,
    activeFilterCount: ComputedRef<number>
): void => {
    const { updateCount } = useFilterButtonCountStore()

    watch(activeFilterCount, updateCount, { immediate: true })

    useListen('open-filter-modal', onOpen)
}
